var isPageLoadFirstTime=true;
 window.AddScaleSlider = function()
    {
        return  `
                <div class="ngs-icon-toolbar">

                    <!-- Mirror -->
                    <button class="ngs-icon-btn" data-action="mirror">
                        <svg xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 30 30"
                              aria-hidden="true">
                              <path fill="currentColor" d="M14.62,4.75H5.45l-.56.56v18.93l.56.56h9.17v4.69h1.12V.5h-1.12v4.25ZM6.01,23.69V5.87h8.61v17.81H6.01Z"/>
                              <rect fill="currentColor" x="17.08" y="23.69" width="1.4" height="1.12"/>
                              <rect fill="currentColor" x="20.28" y="23.69" width="1.8" height="1.12"/>
                              <polygon fill="currentColor" points="24.72 23.69 23.88 23.69 23.88 24.81 25.27 24.81 25.83 24.25 25.83 22.85 24.72 22.85 24.72 23.69"/>
                              <rect fill="currentColor" x="24.72" y="9.94" width="1.12" height="3.23"/>
                              <rect fill="currentColor" x="24.72" y="16.4" width="1.12" height="3.23"/>
                              <polygon fill="currentColor" points="25.27 4.75 23.88 4.75 23.88 5.87 24.72 5.87 24.72 6.71 25.83 6.71 25.83 5.31 25.27 4.75"/>
                              <rect fill="currentColor" x="20.28" y="4.75" width="1.8" height="1.12"/>
                              <rect fill="currentColor" x="17.08" y="4.75" width="1.4" height="1.12"/>
                          </svg>
                          <span class="ngs-icon-label">${local_app_strings.mirrorText}</span>
                    </button>

                    <!-- Greyscale -->
                    <button class="ngs-icon-btn" data-action="greyscale">
                          <svg xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 30 30"
                                  aria-hidden="true">
                                  <path d="M15 3.45c6.38 0 11.55 5.17 11.55 11.55S21.38 26.55 15 26.55z" fill="currentColor"></path>
                                  <path fill="currentColor" d="M15 3h-.45v.02C8.14 3.26 3 8.53 3 15s5.14 11.74 11.55 11.98V27H15c6.62 0 12-5.38 12-12S21.62 3 15 3m11.05 13.12c-.01.13-.04.25-.06.37-.03.24-.06.48-.11.72-.03.15-.07.29-.11.43-.05.21-.1.42-.16.62-.05.15-.11.29-.16.44-.07.19-.13.38-.21.57-.06.15-.13.29-.2.43a5 5 0 0 1-.26.53c-.08.14-.16.27-.24.41-.1.17-.19.34-.3.5-.09.13-.19.26-.28.39-.11.16-.22.31-.34.46-.1.12-.21.24-.32.36-.13.14-.25.29-.39.42-.11.11-.23.22-.35.33-.14.13-.28.26-.42.38-.12.1-.25.2-.38.3a8 8 0 0 1-.87.6c-.16.1-.32.21-.49.3-.14.08-.29.15-.43.22-.17.09-.35.17-.52.25-.15.07-.3.12-.45.18-.18.07-.36.14-.55.2-.16.05-.32.09-.47.14l-.57.15c-.16.04-.33.06-.49.09-.19.03-.39.07-.59.09-.17.02-.34.03-.51.05-.12 0-.24.01-.37.02V3.92c.12 0 .25 0 .37.02.17.01.34.03.51.05.2.02.39.06.59.09.17.03.33.06.49.09q.285.06.57.15c.16.04.32.09.47.14.19.06.37.13.55.2l.45.18c.18.08.35.17.53.25.14.07.29.14.43.22.17.1.33.2.5.3.13.08.27.17.4.26.16.11.31.23.47.35.12.1.25.19.37.29.15.13.29.26.43.39.11.11.23.21.34.32.14.14.26.29.39.43.1.12.21.23.31.35.12.15.24.31.35.47.09.13.19.25.27.38.11.17.21.34.31.51.08.13.16.26.24.4.1.18.18.36.26.55.07.14.14.27.2.42.08.19.14.39.21.58.05.14.11.28.15.43.06.21.11.42.16.63.03.14.08.28.11.42.05.24.08.48.11.72.02.12.04.24.05.36a10.4 10.4 0 0 1 0 2.24ZM3.89 15c0-5.97 4.74-10.85 10.66-11.08v22.17C8.63 25.85 3.89 20.98 3.89 15" ></path>
                            </svg>
                            <span class="ngs-icon-label">Greyscale</span>
                    </button>

                    <!-- Show Panels -->
                    <button class="ngs-icon-btn" data-action="panels">
                        <svg xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 30 30"
                            aria-hidden="true">
                            <path xmlns="http://www.w3.org/2000/svg" fill="currentColor" d="M10.8,2.36h-.95v-1.34h.95v1.34ZM10.8,10.79h-.95v2.81h.95v-2.81ZM10.8,5.17h-.95v2.81h.95v-2.81ZM10.8,22.02h-.95v2.81h.95v-2.81ZM10.8,16.4h-.95v2.81h.95v-2.81ZM9.85,28.98h.95v-1.34h-.95v1.34ZM20.15,1.02h-.95v1.34h.95v-1.34ZM20.15,22.02h-.95v2.81h.95v-2.81ZM20.15,16.4h-.95v2.81h.95v-2.81ZM20.15,10.79h-.95v2.81h.95v-2.81ZM20.15,5.17h-.95v2.81h.95v-2.81ZM19.2,28.98h.95v-1.34h-.95v1.34ZM29.5,3.19v23.4H.5V3.19h29ZM28.55,4.14H1.45v21.5h27.11V4.14Z"/>
                        </svg>
                        <span class="ngs-icon-label">${local_app_strings.showPanelsText}</span>
                    </button>

                    <!-- Reset -->
                    <button class="ngs-icon-btn" data-action="reset">
                        <svg xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 30 30"
                            aria-hidden="true">
                            <path fill="currentColor" d="M12.91,10.09v-5.25s10.64,10.64,10.64,10.64c.8.8.8,2.09,0,2.89l-1.71,1.71.78.78,1.71-1.71c1.22-1.22,1.23-3.22,0-4.44L13.68,4.05h5.25s0-1.05,0-1.05h-7.07v7.09s1.05,0,1.05,0Z"/>
                            <path fill="currentColor" d="M18.14,19.91h-1.05s0,5.25,0,5.25L6.45,14.52c-.8-.8-.8-2.09,0-2.89l1.71-1.71-.78-.78-1.71,1.71c-1.22,1.22-1.23,3.22,0,4.44l10.65,10.65h-5.25v1.05h7.07v-7.09Z"/>
                        </svg>
                        <span class="ngs-icon-label">${local_app_strings.resetText}</span>
                    </button>

                     <!--Scaling  Pattern -->
                    <div class="ngs-pattern-scale">
                        <div class="ngs-scale-header">
                            <span>${local_app_strings.patternScaleText}</span>
                            <span class="ngs-scale-value"><span id="scaleValue">100</span>%</span>
                        </div>
                        <input type="range" id="patternScale" min="70" max="130" step="1" value="100">
                    </div>

                     <!--end Scaling  Pattern -->

                </div>


              
        `
    }

function getDownloadTextureSVG()
{
  return ``
  return ` <svg xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 30 30"
                                                    aria-hidden="true">
 <path fill="currentColor" d="M3.41,7.65c2.91-2.4,5.57-1.55,10.03.16,2.65,1.02,5.5,2.11,8.59,2.11,2.22,0,4.56-.56,7.04-2.13l.44-.27-2.1-3.34-.44.27c-4.26,2.69-8.07,1.22-12.11-.33C10.57,2.48,5.72.62.9,4.61l-.4.33,2.51,3.04.4-.33ZM14.48,5.09c4.15,1.59,8.08,3.11,12.59.51l1.01,1.6c-5.31,3.1-10.07,1.27-14.27-.34-2.57-.99-4.66-1.7-6.56-1.7-1.42,0-2.74.4-4.09,1.39l-1.2-1.46c4.24-3.18,8.63-1.49,12.52,0Z"/>
  <path fill="currentColor" d="M26.96,14.17c-4.26,2.69-8.07,1.22-12.11-.33-4.28-1.64-9.12-3.5-13.95.48l-.4.33,2.51,3.04.4-.33c2.91-2.4,5.57-1.55,10.03.16,2.65,1.02,5.5,2.11,8.59,2.11,2.22,0,4.56-.56,7.04-2.13l.44-.27-2.1-3.34-.44.27ZM13.8,16.55c-2.57-.99-4.66-1.7-6.56-1.7-1.42,0-2.74.4-4.09,1.39l-1.2-1.46c4.24-3.18,8.63-1.49,12.52,0,4.15,1.6,8.08,3.1,12.59.51l1.01,1.6c-5.31,3.1-10.07,1.27-14.27-.34Z"/>
  <path fill="currentColor" d="M26.96,23.87c-4.26,2.69-8.07,1.22-12.11-.33-4.28-1.64-9.12-3.5-13.95.48l-.4.33,2.51,3.04.4-.33c2.91-2.4,5.57-1.55,10.03.16,2.65,1.02,5.5,2.11,8.59,2.11,2.22,0,4.56-.56,7.04-2.13l.44-.27-2.1-3.34-.44.27ZM13.8,26.26c-2.57-.99-4.66-1.7-6.56-1.7-1.42,0-2.74.4-4.09,1.39l-1.2-1.46c4.24-3.18,8.63-1.49,12.52,0,4.15,1.59,8.08,3.11,12.59.51l1.01,1.6c-5.31,3.1-10.07,1.27-14.27-.34Z"/>

                                                  </svg>`
}
function getDownloadSummarySVG()
{
  return ``
  return ` <svg xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 30 30"
                                                aria-hidden="true">

                                                <path fill="currentColor" d="M12.33,3.16V.5H.5v29h29V3.16H12.33ZM28.39,28.39H1.61V1.61h9.61v6.89h17.17v19.89ZM12.33,7.39v-3.12h16.06v3.12H12.33Z"/>
                                                <polygon fill="currentColor" points="9.72 19.47 14.99 24.74 20.28 19.45 19.49 18.67 15.55 22.62 15.55 11.86 14.44 11.86 14.44 22.62 10.51 18.69 9.72 19.47"/>
                                            </svg> `
}
    function addDownloadBuutons()
    {
      let downlaodButtonHtml =` <div class="ngs-download-buttons-wrapper">
                                            <button id="downloadTexture" class="ngs-download-icon-btn" >
                                                ${getDownloadTextureSVG()}
                                                <span class="ngs-download-link-text">${local_app_strings.downloadButtonTextureText}</span>
                                            </button>
                                            <button  id="downloadRepeatImageBtn" class="ngs-download-icon-btn" >
                                                ${getDownloadSummarySVG()}
                                                <span class="ngs-download-link-text">${local_app_strings.downloadButtonText}</span>
                                            </button>
                                            ${getSaveButtonHtml()}
                                  </div>
                                  
                                `

              const targetColumn = document.querySelector('.ngs-controls');
               targetColumn.insertAdjacentHTML('beforeend', downlaodButtonHtml);
                attachDownloadButtonEvents();
    }


   async function onDownloadTexture(e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    let downFileName = window.getDownLoadFileNameNGS('texture');
    /*if (document.querySelector('.product-info__block-list .product-title')){
        downFileName="wallcolors_texture_"+ document.querySelector('.product-info__block-list .product-title').innerHTML;
    }*/
    if (document.querySelector('.product-info__block-list .product-title')) {
      let title = document.querySelector('.product-info__block-list .product-title').textContent.trim();
      downFileName = "wallcolors_texture_" + title;
  }
    downFileName = downFileName.replace(/[ .]/g, "_");

    const div = document.getElementById("divRepeatImageContainer");

    // Get computed background image
    const bgImage = window.getComputedStyle(div).backgroundImage;

    // Extract URL from: url("https://....jpg?v=123")
    const imageUrl = bgImage.replace(/^url\(["']?/, '').replace(/["']?\)$/, '');

    try {
        const response = await fetch(imageUrl, { mode: "cors" });
        if (!response.ok) throw new Error("Failed to fetch image");

        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = `${downFileName}.jpg`;
        document.body.appendChild(link);
        link.click();

        window.URL.revokeObjectURL(blobUrl);
        document.body.removeChild(link);

    } catch (error) {
        console.error("Download failed:", error);
    }
}

async function onDownloadTexture_old(e) {
  e.preventDefault();
  e.stopImmediatePropagation();



                    const top_image_repeat_container = document.querySelector(".ngs-top-image-repeat");
                    const canvas = await window.renderRepeatToCanvas(top_image_repeat_container);
                    
                      const selectedFilterEl = document.querySelector('input[name="ngs-filter"]:checked');
                    const selectedFilter = selectedFilterEl
                        ? selectedFilterEl.getAttribute('data-filter-value')
                        : 'normal';
                    let downFileName = window.getDownLoadFileNameNGS('texture');
                    downFileName = downFileName.replace(/[ .]/g, "_");

                    const link = document.createElement('a');
                    link.download = `${downFileName}.png`;
                    link.href = canvas.toDataURL("image/png");;
                    link.click();
}

async function onDownloadPopup(e) {
  e.preventDefault();
  e.stopImmediatePropagation();
  downloadRepeatImageNew({
    buttonEl: e.currentTarget,
    containerSelector: '.ngs-popup-overlay'
  });
}
    function attachDownloadButtonEvents() {
        const downloadTextureBtn = document.getElementById('downloadTexture');
        const downloadPopupBtn = document.getElementById('downloadRepeatImageBtn');
        const opePopupEmailButton = document.getElementById('btnSaveConfiguration');
        const saveEmailButton = document.getElementById('ngs-email-popup-save-btn');
       const saveMailPopupForm = document.getElementById("frmMailPopup");
        const closeEmailPopupButton = document.getElementById('ngs-email-popup-close');
      
        if (downloadTextureBtn) {
          downloadTextureBtn.removeEventListener('click', onDownloadTexture);
          downloadTextureBtn.addEventListener('click', onDownloadTexture);
        }

        if (downloadPopupBtn) {
          downloadPopupBtn.removeEventListener('click', onDownloadPopup);
          downloadPopupBtn.addEventListener('click', onDownloadPopup);
        }
        if (opePopupEmailButton)
        {
            opePopupEmailButton.removeEventListener('click', openEmailPopup);
            opePopupEmailButton.addEventListener('click', openEmailPopup);
        }
        if (saveMailPopupForm)
        {
            saveMailPopupForm.removeEventListener('submit', saveEmailConfiguration);
            saveMailPopupForm.addEventListener('submit', saveEmailConfiguration);
        }
         if (closeEmailPopupButton)
        {
            closeEmailPopupButton.removeEventListener('click', closeEmailPopup);
            closeEmailPopupButton.addEventListener('click', closeEmailPopup);
        }
        
    }
    function hideMainngsControls()
    {

        const controls = document.querySelector('.ngs-controls');
        const mainHeader = document.querySelector('.ngs-popup-header');
        const mainDescription = document.querySelector('.ngs-popup-description');

        if (controls && mainHeader && mainDescription) {
          // Insert header first
          controls.insertBefore(mainDescription, controls.firstChild);

          // Insert description right after header
          controls.insertBefore(mainHeader, mainDescription.nextSibling);

          const el = document.querySelector('.ngs-popup-description');
        el.textContent = el.textContent.toLowerCase().replace(/^./, c => c.toUpperCase());
        }
        const priceSection = document.querySelector('.ngs-total-section');
        const header = document.querySelector('.ngs-main-top-header');

        if (priceSection && header) {
            header.parentNode.insertBefore(priceSection, header);
            const hr = document.createElement('hr');
            hr.className = 'ngs-price-divider';
            priceSection.appendChild(hr);
        }
        const addToCartBtn = document.getElementById('ngs-add-to-cart');
        const headerDesc = document.querySelector('.ngs-top-header-desc');

        if (addToCartBtn && headerDesc) {
            addToCartBtn.parentNode.insertBefore(
              headerDesc,
              addToCartBtn.nextSibling
            );
        }

        addDownloadBuutons();



        let mainPanelDiv = document.querySelector('.ngs-panel-main-wrapper');
        mainPanelDiv.style.display='none';
        let mainFilterDiv = document.querySelector('.ngs-main-filter');
        mainFilterDiv.style.display='none';
        let mainMirrorDiv = document.querySelector('.ngs-mirror-toggle-container');
        mainMirrorDiv.style.display='none';
        const repeatImageSuggestion = document.querySelector('.ngs-repeat-img-instr');
        repeatImageSuggestion.style.display='none';
    }

    window.attachCustomEventsNGS = async function()
    {

        hideMainngsControls();
        toggleMargin();

        const target = document.querySelector('.ngs-repeat-img-instr');
        if (target) {
            target.insertAdjacentHTML('afterend',AddScaleSlider());

            const slider = document.getElementById('patternScale');
            const output = document.getElementById('scaleValue');
            slider.addEventListener('input', updateSlider);
        }

        document.querySelectorAll('.ngs-icon-btn').forEach(btn => {
            

          
    const handleAction = () => {
        const action = btn.dataset.action;

        if (action === 'reset') {
            resetAction();
            return;
        }

        btn.classList.toggle('active');

        if (action === 'mirror') mirrorAction();
        if (action === 'panels') panelAction();
        if (action === 'greyscale') greyScaleAction();
    };


                      btn.addEventListener('click', (e) => {
        e.preventDefault();
        handleAction();
    });

    // Mobile (instant feedback)
    btn.addEventListener('touchstart', (e) => {
        e.preventDefault();
        handleAction();
    });
            });

            await setConfigurationData();

    } /*end attachCustomEventsNGS*/

    function resetAction()
    {  
         document.querySelectorAll('.ngs-icon-btn')
          .forEach(b => b.classList.remove('active'));
          /* 5️⃣ Reset Pattern Scale → 100% ✅ */
            const scaleSlider = document.getElementById('patternScale');
            const scaleValue = document.getElementById('scaleValue');

            if (scaleSlider) {
              scaleSlider.value = 100;
              if (scaleValue) scaleValue.textContent = '100';

              // trigger existing scale logic
              scaleSlider.dispatchEvent(new Event('input', { bubbles: true }));
              scaleSlider.dispatchEvent(new Event('change', { bubbles: true }));
            }

              const panel = document.getElementById('ngs-panel-toggle');
            if (panel && panel.checked) {
              panel.checked = false;
              panel.dispatchEvent(new Event('change', { bubbles: true }));
            }

            /* 3️⃣ Reset Mirror (if exists) */
            const mirror = document.getElementById('ngs-mirror-toggle');
            if (mirror && mirror.checked) {
              mirror.checked = false;
              mirror.dispatchEvent(new Event('click', { bubbles: true }));
            }

            /* 4️⃣ Reset Filter → Normal */
            const normal = document.getElementById('ngs-filter-normal');
            if (normal && !normal.checked) {
              normal.checked = true;
              normal.dispatchEvent(new Event('change', { bubbles: true }));
            }

           window.updateRepeatImageFromOutside();
    }

    function toggleMargin() {
        const margin = document.getElementById('ngs-margin-toggle-input');
        if (!margin) return;

        margin.checked = !margin.checked;

        // trigger existing margin logic
        margin.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function mirrorAction()
    {
        const mirror = document.getElementById('ngs-mirror-toggle');
        if (!mirror) return;

        // toggle checkbox
        mirror.checked = !mirror.checked;

        // trigger existing mirror logic
        mirror.dispatchEvent(new Event('click', { bubbles: true }));
    }

    function panelAction()
    {
        const checkbox = document.getElementById('ngs-panel-toggle');
        if (!checkbox) return;

        // toggle checkbox
        checkbox.checked = !checkbox.checked;

        // IMPORTANT: trigger existing logic
        checkbox.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function greyScaleAction()
    {
        const normal = document.getElementById('ngs-filter-normal');
        const grayscale = document.getElementById('ngs-filter-grayscale');

        if (!normal || !grayscale) return;

        // Toggle between Normal <-> Grayscale
        const makeGreyscale = normal.checked;

        grayscale.checked = makeGreyscale;
        normal.checked = !makeGreyscale;

        // Trigger existing logic
        const target = makeGreyscale ? grayscale : normal;
        target.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function updateSlider() 
    {
        const slider = document.getElementById('patternScale');
        const output = document.getElementById('scaleValue');
        const min = slider.min;
        const max = slider.max;
        const val = slider.value;

        output.textContent = val;

        const percent = ((val - min) / (max - min)) * 100;

        slider.style.background = `
        linear-gradient(
            to right,
            #000 0%,
            #000 ${percent}%,
            #d9d9d9 ${percent}%,
            #d9d9d9 100%
        )
        `;
        window.updateRepeatImageFromOutside();

    }


    function getRenderState(container) {
  return {
    mirror: document.querySelector('.ngs-actual-image-repeat').classList.contains("mirror1"),

    greyscale: document
      .querySelector('[data-action="greyscale"]')
      ?.classList.contains("active"),

    panels: document
      .querySelector('[data-action="panels"]')
      ?.classList.contains("active"),

    panelSize: parseFloat(
      container.querySelector(".ngs-grid-panel-lines")?.style.backgroundSize
    ) || 0
  };
}


  window.renderRepeatToCanvas = async function(container) {
   await addCustomCartPropertyDesignerView();
  const rect = container.getBoundingClientRect();
  const repeatDiv = container.querySelector('.ngs-actual-image-repeat');
  const bg = window.getComputedStyle(repeatDiv);

  const imageUrl = bg.backgroundImage.slice(5, -2);
  const [tileW, tileH] = bg.backgroundSize.split(" ").map(parseFloat);
  const bgPosX = parseFloat(bg.backgroundPositionX);
  const bgPosY = parseFloat(bg.backgroundPositionY || 0);

  const state = getRenderState(container);

  const canvas = document.getElementById("previewCanvas");
  canvas.width = rect.width;
  canvas.height = rect.height;

  const ctx = canvas.getContext("2d");

  return new Promise(resolve => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.src = imageUrl;

    img.onload = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      /* ========= MIRROR ========= */
      if (state.mirror) {
        ctx.translate(canvas.width, 0);
        ctx.scale(-1, 1);
      }

      /* ========= GREYSCALE ========= */
      ctx.filter = state.greyscale ? "grayscale(100%)" : "none";

      /* ========= TILE SOURCE ========= */
      const patternCanvas = document.createElement("canvas");
      patternCanvas.width = tileW;
      patternCanvas.height = tileH;
      patternCanvas.getContext("2d").drawImage(img, 0, 0, tileW, tileH);

      const pattern = ctx.createPattern(patternCanvas, "repeat");

      ctx.translate(bgPosX, bgPosY);
      ctx.fillStyle = pattern;
      ctx.fillRect(-bgPosX, -bgPosY, canvas.width, canvas.height);

      /* ========= RESET TRANSFORM ========= */
      ctx.resetTransform();
      ctx.filter = "none";

      /* ========= PANELS ========= */
      if (state.panels && state.panelSize) {
  ctx.save();

  ctx.strokeStyle = "rgba(0, 120, 255, 0.85)"; // BLUE
  ctx.lineWidth = Math.max(2, window.devicePixelRatio);

  for (let x = state.panelSize; x < canvas.width; x += state.panelSize) {
    ctx.beginPath();
    ctx.moveTo(x + 0.5, 0);
    ctx.lineTo(x + 0.5, canvas.height);
    ctx.stroke();
  }

  ctx.restore();
}

      resolve(canvas);
    };
  });
}


window.downloadRepeatImageNew = async function({ buttonEl, containerSelector }) {
    const imageContainer =
    document.querySelector(".ngs-top-image-repeat");

  document.querySelectorAll('.ngs-spinner').forEach(el => {
    el.style.border = "2px solid black";
  });

  // Persist checked state
  document.querySelectorAll('input[name="ngs-filter"]').forEach(el => {
    if (el.checked) {
      el.setAttribute("checked", "checked");
    } else {
      el.removeAttribute("checked");
    }
  });

  const node = document.querySelector(containerSelector);
  const selectedFilterEl = document.querySelector('input[name="ngs-filter"]:checked');
  const selectedFilter = selectedFilterEl
    ? selectedFilterEl.getAttribute('data-filter-value')
    : 'normal';

    const state = getRenderState(document.querySelector('.ngs-top-image-repeat'));
    const changeDiv= document.querySelector('.ngs-top-image-repeat');
    changeDiv.style.transform = state.mirror ? 'scaleX(-1)' : '';
    changeDiv.style.filter = state.greyscale ? 'grayscale(100%)' : 'none';


  const dataUrl = await domtoimage.toPng(node);
  
    changeDiv.style.transform = '';
changeDiv.style.filter = '';

  let downFileName =  window.getDownLoadFileNameNGS('summary');
  downFileName = downFileName.replace(/[ .]/g, "_");

  const link = document.createElement('a');
  link.download = `${downFileName}.png`;
  link.href = dataUrl;
  link.click();

  hideSpinner_new(buttonEl)
}

 function hideSpinner_new(button, isFromSample = false) {
            let spinnerClassName = 'ngs-spinner';
            if (isFromSample) {
                spinnerClassName = 'ngs-spinner-sample';
            }

            // Remove the spinner if it exists
            const spinner = button.querySelector('.' + spinnerClassName);
            if (spinner) {
                spinner.remove();
            }

            // Show button text again
            const text = button.querySelector('.ngs-button-text');
            if (text) {
                text.style.visibility = 'visible';
            }

            button.classList.remove('ngs-button-loading');
        }

        window.AddSampleOrderButton = function(sampleButtonText)
        {
           const newButton = document.createElement('button');
            newButton.id = 'ngs-sample-order-btn'; // Set an ID for the button
            newButton.className = 'ngs-sample-order-btn';
            const targetButton = document.querySelector('#ngs-show-popup-btn');
            

            if (targetButton) {

                const buttonText = document.createElement('span');
            buttonText.className = 'ngs-button-text';
            buttonText.textContent = sampleButtonText;
            newButton.appendChild(buttonText);

                targetButton.insertAdjacentElement('afterend', newButton);

                const parent = targetButton.parentElement;
                const buyButtons = parent.querySelector('buy-buttons');

                if (buyButtons) {
                   buyButtons.parentElement.style.display = 'none';
                    buyButtons.style.display = 'none';
                }

                   newButton.addEventListener('click', async (e) => {
                      e.preventDefault();
                     
                    sampleOrderClickEvent();
                      
                      return false;
                 });
            }

          

        }

        function sampleOrderClickEvent()
        {

            const targetButton = document.querySelector('#ngs-show-popup-btn');
            const parent = targetButton.parentElement;
            const buyButtons = parent.querySelector('buy-buttons');

            const excludedIds = [
                'ngs_custom_price_product_text',
               
                'ngs_all_properties_data',
                'ngs_extra_margin',
                'ngs_image_color_option',
                'ngs_mirror_option',
                'ngs_panel_option',
                'ngs_scaling_option',
                'ngs-photo',
                'ngs_custom_spl_notes'
          ];
   const removedInputs = removeAddToCartProps(excludedIds)
            // Select all property inputs (hidden or normal)
   
            const sampleOrderPrice= 15;
            if (!document.getElementById('ngs_custom_final_custom_size')) {

                  const priceElement = document.getElementById('ngs_custom_final_price');

                  if (priceElement) {
                      const input = document.createElement('input');
                      input.id = 'ngs_custom_final_custom_size';
                      input.type = 'hidden';
                      input.name = 'properties[Size]';
                      input.value = '0';

                      priceElement.parentNode.insertBefore(input, priceElement);
                  }
          }
          const wallProperty = document.querySelector('.ngs-wall-property');

          if (wallProperty) {
            wallProperty.innerHTML = '';
          }

           const wallConnectedProperty = document.querySelector('#ngs_connectedRooms');

          if (wallConnectedProperty) {
            wallConnectedProperty.value = 'No';
          }

           document.getElementById('ngs_custom_final_custom_size').value =`${local_app_strings.sampleText} 30x84 cm / 11x33 in`
            let final_item_price = (sampleOrderPrice * Shopify.currency.rate);
             let tmp_custom_price = parseFloat(final_item_price);
            document.getElementById('ngs_custom_final_price').value = final_item_price.toFixed(2)
            document.getElementById('ngs_product_base_price').value = tmp_custom_price.toFixed(2)
            try {
                let finalCPrice = (final_item_price / Shopify.currency.rate).toFixed(2)
                document.getElementById('ngs_custom_final_price').value = finalCPrice

                document.getElementById('ngs_product_base_price').value = (tmp_custom_price / Shopify.currency.rate).toFixed(2)
                document.getElementById('ngs_original_currency').value = Shopify.currency.active;

                const innerButton = buyButtons.querySelector('button[type="submit"]');
                innerButton.click();

            setTimeout(() => {
               document.getElementById('ngs_custom_final_custom_size').value =""
                    removedInputs.forEach(item => {
                        item.element.setAttribute('name', item.originalName);
                        // OR item.element.disabled = false;
                    });
                }, 500);
                 



            }
            catch (ex) {

            }
        }

        function removeAddToCartProps(excludedIds)
        {
          

                  const removedInputs = [];

                  excludedIds.forEach(id => {
                  const input = document.getElementById(id);

                  if (input && input.name) {
                  removedInputs.push({
                  element: input,
                  originalName: input.name
                  });

                  input.removeAttribute('name'); 
                  // OR input.disabled = true;
                  }
                  });
                return removedInputs;
        }


let domainapiURL='https://app.wallcolors.com'
var savedConfigureData  = null;
var savedConfigurationId = '';
   

async function getConfigureDetails(configurationId) {

    // 1️⃣ First check global variable (fastest)
    if (savedConfigureData) {
        return savedConfigureData;
    }
   // 4️⃣ Fetch from API
    const formData = new URLSearchParams();
    formData.append("configuration_id", configurationId);

    const response = await fetch(`${domainapiURL}/get_configuration.php`, {
        method: "POST",
        body: formData
    });

    const result = await response.json();

    if (result.status) {
        console.log("Config loaded from API");
        savedConfigureData = result.config;
        return result.config;

    } else {
        console.error("Error:", result.message);
        return null;
    }
}
   

      function saveOffsetValue() {

            const el = document.getElementById('divRepeatImageContainer');

            const bgSize = window.getComputedStyle(el)
                .backgroundSize.split(" ");

            const tileWidth = parseFloat(bgSize[0]);

            const currentPos =
                parseFloat(window.getComputedStyle(el).backgroundPositionX);

            // Normalize inside one tile
            const ratio = (currentPos % tileWidth) / tileWidth;

            return ratio;
      }

      function applySavedOffset(savedRatio) {

            const el = document.getElementById('divRepeatImageContainer');

            const bgSize = window.getComputedStyle(el)
                .backgroundSize.split(" ");

            const tileWidth = parseFloat(bgSize[0]);

            const newPos = savedRatio * tileWidth;

            el.style.backgroundPositionX = `${newPos}px`;
      }

        function resetImageOffsets(savedRatio)
        {
            let bounds = window.getRepeatBounds();

            let totalDraggableWidth =
                window.getRepeatImageState().repeatBaseBackgroundX + (bounds.max - bounds.min);

            let calculatedVisualPosition =
                savedRatio * totalDraggableWidth;

            return window.getRepeatImageState().repeatBaseBackgroundX - calculatedVisualPosition;
        }

       
       async function setConfigurationData()
        {
              if (isPageLoadFirstTime== false)
              {
                return;
              }
              isPageLoadFirstTime= false;
              if (savedConfigureData == null)
              {
                return ;
              }
         
             
              let configureData = savedConfigureData;
              document.getElementById('ngs-spl-instructions').value = configureData.specialNotes;
              if (configureData.margin == "NO")
              {
                toggleMargin();
              }
              setMeasurementToggle(configureData.measurementType)
              document.querySelector('#ngs-width-input').value= configureData.width
              document.querySelector('#ngs-height-input').value= configureData.height
              const input = document.querySelector('#ngs-width-input');
              input.dispatchEvent(new Event('input', {
                  bubbles: true
              }));
               input.dispatchEvent(new Event('change', {
                  bubbles: true
              }));
             
              if (configureData.greyScale=="YES")
              {
                   const greyScaleButton = document.querySelector('[data-action="greyscale"]');

                    if (greyScaleButton) {
                        greyScaleButton.click();
                    }
              }
               if (configureData.showPanels=="YES")
              {
                   const panelButton = document.querySelector('[data-action="panels"]');

                    if (panelButton) {
                        panelButton.click();
                    }
              }
              if (configureData.patternScale!= "100")
              {
                document.getElementById('patternScale').value =configureData.patternScale
                  updateSlider();
              }
             
              if (configureData.mirrorRequired=="YES")
              {
                   const mirrorButton = document.querySelector('[data-action="mirror"]');

                    if (mirrorButton) {
                        mirrorButton.click();
                    }
              }
              
               localStorage.removeItem("productConfiguration");
             
              applySavedOffset(configureData.saveOffsetValue)
           
              
        }



      function setMeasurementToggle(measurementType) 
      {
          if (!measurementType) return;
          if (measurementType === 'inch') {

            document.querySelector('.ngs-measure-unit-toggle').click();
          }
    }

    async function closeEmailPopup(e)
    {
         e.preventDefault();
           document.getElementById("ngs-email-popup").classList.remove("ngs-email-active");
         return;
    }

    
    async function openEmailPopup(e)
    {
         e.preventDefault();
         document.getElementById("ngs-email-popup").classList.add("ngs-email-active");
         return;
    }

    async function getDesignerViewURL()
    {
        let configureData= await getCurrentPopupDetailsData();
         try {
              const formData = new URLSearchParams();
              formData.append("config", JSON.stringify(configureData));
             const response = await fetch(`${domainapiURL}/designerview_configuration.php`, {
                                            method: "POST",
                                            body: formData
                                        });

              const result = await response.json();

              if (result.status) {
                return result.configuration_id
              } else {
                return ''
                  console.error("Error:", result.message);
              }

          } catch (error) {
             return ''
              console.error("Request failed:", error);
          }
    }
    async function getCurrentPopupDetailsData()
    {
       const url = new URL(window.location.href);

      url.searchParams.delete("configurationId");
      url.searchParams.delete("isMCR");

      const product_url = url.toString();
      let configureData={
                            measurementType:  document.querySelector('.ngs-measure-unit-toggle').getAttribute('data-current-value'),
                            width: document.querySelector('#ngs-width-input').value,
                            height:document.querySelector('#ngs-height-input').value,
                            specialNotes: document.getElementById('ngs-spl-instructions').value,
                            margin: document.querySelector('#ngs-margin-toggle-input').checked ? "YES" : "NO",
                            mirrorRequired :  document.getElementById('ngs-mirror-toggle').checked ? "YES" : "NO",
                            greyScale: document.querySelector('[data-action="greyscale"]')?.classList.contains('active') ? "YES" : "NO",
                            showPanels:document.getElementById('ngs-panel-toggle').checked ? "YES" : "NO",
                            patternScale:document.getElementById('patternScale').value,
                            saveOffsetValue :saveOffsetValue(),
                            productName:document.querySelector('.ngs-popup-header').innerText,
                            product_url:product_url,
                            country:Shopify.country
                          }
                          return configureData;
    }
    async function saveEmailConfiguration(e)
    {
        e.preventDefault();
       // alert(window.ShopifyCustomer.email)
        let email = window.ShopifyCustomer.email ;//"nageshhello777@gmail.com";
        //email ="nageshhello777@gmail.com";
       // email="kamil@wallcolors.com";
        let configureData= await getCurrentPopupDetailsData();
     
            try {
              const formData = new URLSearchParams();
              formData.append("email", email);
              formData.append("emailSubject", document.querySelector('#ngs-email-subject').value);
              formData.append("config", JSON.stringify(configureData));
             const response = await fetch(`${domainapiURL}/save_configuration.php`, {
                                            method: "POST",
                                            body: formData
                                        });

              const result = await response.json();

              if (result.status) {
                alert(`${local_app_strings.emailSent}`)
                  console.log("Saved successfully");
                  console.log("Encrypted ID:", result.configuration_id);
              } else {
                  alert('There is an error.')
                  console.error("Error:", result.message);
              }

          } catch (error) {
              alert('There is an error.')
              console.error("Request failed:", error);
          }
    }


   document.addEventListener("DOMContentLoaded", async function () {

    const urlParams = new URLSearchParams(window.location.search);

    const configurationId = urlParams.get("configurationId");
    const isManualCurrency = urlParams.get("isMCR");

    // Run only if configurationId exists
    if (!configurationId) return;

    const configuredData = await getConfigureDetails(configurationId);
    if (!configuredData) return;

    const savedCountry = (configuredData?.country || "PL").toUpperCase();
    const currentCountry = Shopify.country;

    console.log("Saved:", savedCountry);
    console.log("Current:", currentCountry);

    // Only change currency if user didn't manually change it
    if (!isManualCurrency && savedCountry !== currentCountry) {

        const countryButton = document.querySelector(
            `button[name="country_code"][value="${savedCountry}"]`
        );

        if (countryButton) {
           window.isAutoCurrencyChange = true; // 
            countryButton.click();
            return;
        }
    }
    if (savedCountry == currentCountry)
    { 
      
              const ngsinterval = setInterval(() => {

            const btn = document.querySelector('#ngs-show-popup-btn');

            if (btn) {
              
               setTimeout(() => {
                btn.click();
              }, 1800); 

              clearInterval(ngsinterval); // ✅ stop checking once found
            }

          }, 800); 
    }

});

document.addEventListener("click", function (e) {

    // First check current page URL
    const pageUrl = new URL(window.location.href);

    if (!pageUrl.searchParams.has("configurationId")) {
        return; // No configurationId → do nothing
    }
     if (window.isAutoCurrencyChange) {
        window.isAutoCurrencyChange = false;
        return;
    }

    const btn = e.target.closest('button[name="country_code"]');
    if (!btn) return;

    const form = btn.closest("form");
    if (!form) return;

    const returnInput = form.querySelector('input[name="return_to"]');
    if (!returnInput) return;

    const url = new URL(returnInput.value, window.location.origin);

    // Add manual currency change flag
    url.searchParams.set("isMCR", "1");

    returnInput.value = url.pathname + url.search;

});



function getSaveButtonHtml() {
 /* return `<div>
        <button class="ngs-download-icon-btn" id="btnSaveConfiguration">
            ${local_app_strings.saveAndMailButtonText}
        </button>
         ${getEmailPopupHTML()}
    </div>`;*/
  
        let requiredTags = ['saveEmailButton'];

        // Check login
        if (!window.ShopifyCustomer.loggedIn) {
            return '';
        }

        // Convert requiredTags to lowercase
        const requiredTagsLower = requiredTags.map(tag => tag.toLowerCase());

        // Get customer tags and convert to lowercase
        const customerTags = (window.ShopifyCustomer.tags || []).map(tag => tag.toLowerCase());

        // Check tag match
        const hasRequiredTag = requiredTagsLower.some(tag =>
            customerTags.includes(tag)
        );

        if (!hasRequiredTag) {
            return '';
        }

    return `<div>
        <button class="ngs-download-icon-btn" id="btnSaveConfiguration">
            ${local_app_strings.saveAndMailButtonText}
        </button>
        ${getEmailPopupHTML()}
    </div>`;
}

function getEmailPopupHTML()
{
  return `
  <form id="frmMailPopup"><div id="ngs-email-popup" class="ngs-email-popup-overlay">

          <div class="ngs-email-popup-box">

              <div class="ngs-email-popup-header">
                  <span>${local_app_strings.emailPopupHeaderText}</span>
                  <button id="ngs-email-popup-close">&times;</button>
              </div>

              <div class="ngs-email-popup-body">
                  <label>${local_app_strings.emailprojectNameText}</label>
                  <input type="text" id="ngs-email-subject" name="ngs-email-subject" required placeholder="${local_app_strings.emailprojectNamePlaceHolderText}" />
                  <p class="ngs-emailpopup-desc">${local_app_strings.emailpopupinfo}</p>
              </div>

              <div class="ngs-email-popup-footer">
                  <button type="submit" id="ngs-email-popup-save-btn" class="ngs-download-icon-btn">${local_app_strings.emailpopupSaveButton}</button>
              </div>

          </div>

</div>
</form>`
}

async function addCustomCartPropertyDesignerView()
{
   let designerViewURL = await getDesignerViewURL()
   if (document.getElementById("ngs_designerViewURL")) {

     document.getElementById("ngs_designerViewURL").value=designerViewURL;
        
    }
}

/*start roll over popup */

let actualProductFormLocal= 'product-form .shopify-product-form'
window.BuildNoVisualImageRollCalcualtionPopup = function(popup,showPopup,apiMainSettingsData,apiMainProductsData,custom_price)
{
  
    wallActualSQMPrice =custom_price;
    //wallRollPrice = Shopify.currency.rate* ngsWallRollPrice;
   wallRollPrice = custom_price
    if (apiMainProductsData.productURL && apiMainProductsData.productURL.trim() !== '') {
        rollLeftImaeURL = apiMainProductsData.productURL.trim();
    }
  
   if (document.querySelector('.ngs-popup-overlay')) 
    {
          let productName= document.querySelector('.product-info__block-list .product-title').innerText
          popup.innerHTML = getRollpopupHtmlForNoVisualImage(productName)
        //  document.body.insertAdjacentHTML("beforeend",getRollpopupHtmlForNoVisualImage(productName));
          const el = document.querySelector('.ngs-popup-description');
          el.textContent = el.textContent.toLowerCase().replace(/^./, c => c.toUpperCase());
            ngsnvRollpopupInchChangeEvent()
            addWall();
            hideRollNoVisual()
            nvRollAddtoCart()
            connectWallroomToggeleEvent();
            window.hideSpinner(showPopup)
            addCutomPropertiesToForm(apiMainSettingsData)
    }
}

function rollPriceValue() {
    let priceElementClass = 'sale-price.h4.text-subdued';
    const priceElement = document.querySelector(priceElementClass);

    let priceText = priceElement?.childNodes[priceElement.childNodes.length - 1].textContent.trim();

    // remove currency symbol and keep only number
    let priceValue = priceText.replace(/[^\d.]/g, '');

    return priceValue;
}
function getNVRollProductFromButtonElement()
{
  const visibleForm = [...document.querySelectorAll(actualProductFormLocal)]
  .find(el => el.offsetParent !== null);

  if(!visibleForm) return null;

  return visibleForm.querySelector('buy-buttons button[type="submit"]');
}

function nvRollAddtoCart()
{
     document.querySelector('.ngs-nv-roll-add-to-cart').addEventListener('click', function () 
     {

        
        const isValid = validateWallInputs();
        if (isValid)
        {
          const submitBtn = getNVRollProductFromButtonElement();  
           if(submitBtn){
            CalculateRollForNoVisual(1)
         // document.querySelector('quantity-input [name="quantity"]').value=parseInt(document.getElementById("rollCount").innerText);
            submitBtn.click();
          }
        }
       
    });
}

function validateWallInputs() {
    const widthInputs = document.querySelectorAll(".ngs-width");
    const heightInput = document.querySelector(".ngs-height");

    let isValid = true;

    // Validate all width inputs
    widthInputs.forEach(input => {
        let value = parseFloat(input.value);

        if (
            input.value.trim() === "" || 
            isNaN(value) || 
            value <= 0
        ) {
            isValid = false;
        }
    });

    // Validate height input
    let heightValue = parseFloat(heightInput.value);

    if (
        heightInput.value.trim() === "" || 
        isNaN(heightValue) || 
        heightValue <= 0
    ) {
        isValid = false;
    }

    if (!isValid) {
        alert(`${local_app_strings.rollValidationMessage}`);
        return false;
    }

    return true;
}

function hideRollNoVisual()
{
  document.getElementById("ngs-popup-close-btn").onclick = function(){
     document.body.classList.remove('ngs-no-scroll');
    document.querySelector(".ngs-popup-overlay").style.display = "none";
    }
}
function connectWallroomToggeleEvent()
{
  let pricePerSqm = 200;
   document
.getElementById("ngs-connect-wall-toggle-input")
.addEventListener("change", function () {

    const note = document.getElementById("wallConnectNote");

    if (this.checked) {
        note.style.display = "block";
        let currentCurrenyLocal = Shopify.currency.active.toLowerCase()
        if (currentCurrenyLocal =='pln')
        {
          wallRollPrice = parseFloat(wallActualSQMPrice)+ parseFloat(10)
        }
        else  if (currentCurrenyLocal =='usd')
        {
          wallRollPrice = parseFloat(wallActualSQMPrice)+ parseFloat(2)
        }
         else  if (currentCurrenyLocal =='eur')
        {
          wallRollPrice = parseFloat(wallActualSQMPrice)+ parseFloat(2)
        }
          else  if (currentCurrenyLocal =='gbp')
        {
          wallRollPrice = parseFloat(wallActualSQMPrice)+ parseFloat(2)
        }
          else  if (currentCurrenyLocal =='cad')
        {
          wallRollPrice = parseFloat(wallActualSQMPrice)+ parseFloat(3)
        }

    } else {
        note.style.display = "none";
         wallRollPrice = wallActualSQMPrice
    }
    document.querySelector('#ngs-measure-price').innerHTML = `(${rollPriceSymbol()}  ${parseFloat(wallRollPrice).toFixed(2)} / m<sup>2</sup>)`
    
    CalculateRollForNoVisual(0)

});
}
function rollPriceSymbol()
{
   let priceElementClass = 'sale-price.h4.text-subdued'
     const priceElement = document.querySelector(priceElementClass);
    let  priceText = priceElement?.childNodes[priceElement.childNodes.length - 1].textContent.trim();
     priceText = priceText.replace(/\/\s*\S+$/, '').trim();

        // Match currency symbol (non-digit characters before or after number)
        const currencyMatch = priceText.match(/([^\d\s.,]+)/);


                // Regular expression to extract the currency symbol
               // const currencyMatch = priceText.match(/^[^\d\s]+|[^\d\s]+$/);

                
                 let   priceSymbol = currencyMatch[0] + ' ';
    return priceSymbol

}
function getRollpopupHtmlForNoVisualImage(productName)
{
  
  return `
       
              <div class="ngs-popup-content">
                  <button id="ngs-popup-close-btn" class="ngs-popup-close-btn">×</button>
                  <div class="ngs-nv-roll-grid">
                  <!-- LEFT -->
                      <div class="ngs-nv-roll-left">
                          <img src="${rollLeftImaeURL}">
                      </div>
                  <!-- CENTER -->

                      <div class="ngs-nv-roll-middle">
                       <div class="ngs-controls">
                          <div class="ngs-tog-measure-unit">
                                <div tabindex="0" class="ngs-msr">cm</div> 
                                <span data-current-value="cm" class="ngs-measure-unit-toggle toggle"></span> 
                                <div tabindex="0" class="ngs-msr">Inch</div>
                          </div>
                         
                        <div id="ngs-nv-roll-height-walls">
                             <div class="ngs-nv-roll-height-row">
                           
                                 <div class="ngs-dimension-title ngs-height-title ngs-nv-roll-height-title">${local_app_strings.rollHeight}</div>
                                  <div class="ngs-dimension-input-group ngs-nv-roll-height-input">
                                      <input type="number" step="0.01" min="0" value="" class="ngs-dimension-input ngs-height" placeholder="cm">
                                  </div>
                              </div>
                          </div>

                          <div id="ngs-nv-roll-add-walls"></div>


                          <div class="ngs-add-wall" onclick="addWall()">
    <div class="ngs-add-wall-icon">+</div>
    <span class="ngs-add-wall-text">${local_app_strings.addAnotherWall}</span>
</div>

                          
                         
                          </div>
                      </div>


                    <!-- RIGHT -->

                    <div class="ngs-nv-roll-right ngs-controls">
                    <div class="ngs-popup-description">${local_app_strings.wallAndRollText}</div>
                    <h2 class="ngs-popup-header">${(productName).toUpperCase()}</h2>
                                
                                  <div class="ngs-input-other-item ngs-total-section">
        <label> <span id="ngs-final-price">${rollPriceSymbol()}  </span>
    
        <span id="ngs-measure-price">(${rollPriceSymbol()}  ${parseFloat(wallRollPrice).toFixed(2)} / m<sup>2</sup>)</span> 
        </label>
        <hr class="ngs-price-divider"></div>
        <div class="ngs-main-top-header">
            <div class="ngs-top-header">${local_app_strings.youNeed}</div>
        </div>
                
                    
                        <div id="summary"></div>

                        <div class="total">
                          ${local_app_strings.totalRolls}: <span id="rollCount">0</span>
                        </div>

                     <div>
                        <label class="ngs-connect-wall-toggle-wrapper ngsHide">
                            <input type="checkbox" id="ngs-connect-wall-toggle-input" class="ngs-connect-wall-toggle-input" hidden="">
                            <span class="ngs-connect-wall-toggle"></span>
                            <span class="ngs-connect-wall-toggle-text">${local_app_strings.connectTheRooms}</span>
                        </label>
                    </div>

                    <div id="wallConnectNote" class="ngs-wall-note" style="display:none;">
                        ${local_app_strings.connectTheRoomsNotes}
                    </div>

                        <div class="ngs-input-other-item ngs-spl-notes">
                                <label for="ngs-instructions">${local_app_strings.splNotesText}</label>
                                <textarea id="ngs-spl-instructions"></textarea>
                            </div>
                       <button style="width:100%" id="ngs-add-to-cart" class="ngs-nv-roll-add-to-cart">  <span class="ngs-button-text">${local_app_strings.addToCartButtonText}</span></button>
                    </div>


            </div>
             </div>
              
  `
}

function ngsnvRollpopupInchChangeEvent()
{
   if (document.querySelector('.ngs-measure-unit-toggle') != null) {
let measurementTypes='cm,inch'
                document.querySelector('.ngs-measure-unit-toggle').addEventListener('click', function () {

                    let toggle = this;
                    let currentValue = toggle.getAttribute('data-current-value');
                    
                    /*
                    let newValue = currentValue === 'inch' ? 'cm' : 'inch';*/
                    let arrMeasurementTypes = measurementTypes.split(',');

                    let currentIndex = arrMeasurementTypes.indexOf(currentValue);
                    let newIndex = (currentIndex + 1) % arrMeasurementTypes.length;
                    let newValue = arrMeasurementTypes[newIndex];



                    toggle.setAttribute('data-current-value', newValue);
                    toggle.setAttribute('data-index', newIndex);
                    convertWallValues(newValue)
                });
              }     

}
function convertWallValues(newUnit){
  let heightInput = document.querySelector(".ngs-nv-roll-height-input .ngs-height");
let h = parseFloat(heightInput.value);
heightInput.placeholder = newUnit;
if (isNaN(h))
{
  h= parseFloat(0)
}


if(newUnit === "inch"){

heightInput.value = (h / 2.54).toFixed(2);
}

// inch → cm
if(newUnit === "cm"){

heightInput.value = (h * 2.54).toFixed(2);
}
document.querySelectorAll(".ngs-nv-roll-wall").forEach(wall=>{

let widthInput = wall.querySelector(".ngs-width");


let w = parseFloat(widthInput.value);


// update placeholders
widthInput.placeholder = newUnit;


if(!w) return;

// cm → inch
if(newUnit === "inch"){
widthInput.value = (w / 2.54).toFixed(2);

}

// inch → cm
if(newUnit === "cm"){
widthInput.value = (w * 2.54).toFixed(2);

}

});

CalculateRollForNoVisual(0);
}
function removeWall(btn){

btn.closest(".ngs-nv-roll-wall").remove()

reorder()
toggleConnectWallSection();
CalculateRollForNoVisual(0)

}

function toggleConnectWallSection() {
    let wallCount = document.querySelectorAll(
        '#ngs-nv-roll-add-walls .ngs-nv-roll-wall'
    ).length;

    let section = document.querySelector('.ngs-connect-wall-toggle-wrapper');
    let checkbox = document.getElementById('ngs-connect-wall-toggle-input');

    if (wallCount > 3) {
        section.classList.remove('ngsHide');
        section.classList.add('ngsShow');

        // default unchecked when visible
        checkbox.checked = false;
    } else {
        section.classList.remove('ngsShow');
        section.classList.add('ngsHide');

        checkbox.checked = false;
    }
}

function addWall(){

let div=document.createElement("div")

div.className="ngs-nv-roll-wall"

div.innerHTML=`

  <div class="wallHeader">

      <div class="ngs-nv-roll-width-row">
                           
                                 <div class="ngs-dimension-title ngs-height-title ngs-nv-roll-width-title">${local_app_strings.mainWidthText}</div>
                                  <div class="ngs-dimension-input-group ngs-nv-roll-width-input">
                                      <input type="number" step="0.01" min="0" value="" class="ngs-dimension-input ngs-width" placeholder="cm">
                                       <button class="ngs-nv-roll-remove" onclick="removeWall(this)">x</button>
                                      
                                    </div>
                                   
                              </div>

     

    </div>





<hr class="ngs-price-divider">

`

document.getElementById("ngs-nv-roll-add-walls").appendChild(div)

bindInputs()
reorder()
toggleConnectWallSection();
CalculateRollForNoVisual(0);
}


function reorder(){

let walls=document.querySelectorAll(".ngs-nv-roll-width-title")

walls.forEach((wall,i)=>{

wall.innerText=`${local_app_strings.wall} ${i+1}: ${local_app_strings.mainWidthText}`

})

}
function bindInputs(){

  document.querySelectorAll(".ngs-width, .ngs-height")
  .forEach(el => {

    el.oninput = function(){
      CalculateRollForNoVisual(0)
    }

  })

}
function localConvertToSquareMeters(width, height, measureType) {
            measureType = measureType.toLowerCase();
            let adjustValue = 0;
            width = width + adjustValue
            height = height + adjustValue
            if (measureType === 'feet') {
                return (width * 0.3048) * (height * 0.3048);
            } else if (measureType === 'inch') {
                return (width * 0.0254) * (height * 0.0254);
            } else if (measureType === 'cm') {
                return (width * 0.01) * (height * 0.01);
            } else if (measureType === 'meter') {
                // If the measureType is already in meters
                return width * height;
            } else if (measureType === 'mm') {
                return (width * 0.001) * (height * 0.001);
            }
            else {
                throw new Error("Invalid measureType");
            }
        }


function CalculateRollForNoVisual(isFromCart=0){

let total = 0
let html = ""
let propertiesHtml =''
let toalPrice=0;
let totalWidthValue = 0
let unit = document.querySelector('.ngs-measure-unit-toggle')
.getAttribute('data-current-value')

document.querySelectorAll(".ngs-nv-roll-wall").forEach((wall,i)=>{

let w = parseFloat(wall.querySelector(".ngs-width").value)
if (isNaN(w)) {
    w = parseFloat(0);
}
totalWidthValue = totalWidthValue + w;
 /* if (isFromCart==1)
  {
    let value = ` ${rolls} rolls of ${displayWidth}x${displayHeight} ${displayUnit}`
    propertiesHtml += `
    <input type="hidden" 
    name="properties[Wall ${i+1}]" 
    value="${value}">`
  }*/

})

let h = parseFloat(document.querySelector(".ngs-nv-roll-height-row .ngs-height").value)
if (isNaN(totalWidthValue)) {
    totalWidthValue = parseFloat(0);
}

if (isNaN(h)) {
    h = parseFloat(0);
}

if (totalWidthValue < 0 || h < 0) return;


// always convert to cm internally
let wcm = unit === "inch" ? totalWidthValue * 2.54 : totalWidthValue
let hcm = unit === "inch" ? h * 2.54 : h

// roll calculation
let rolls = Math.ceil(wcm / 100)

let rollHeight = Math.ceil(hcm / 100) * 100
if(rollHeight < 200) rollHeight = 200

total += rolls

// convert result for display
let displayWidth = 100
let displayHeight = rollHeight
let displayUnit = "cm"

if(unit === "inch"){
  displayWidth = (100 / 2.54).toFixed(2);
  displayHeight = (rollHeight / 2.54).toFixed(2);
  displayUnit = "in";
}


let area = localConvertToSquareMeters(displayWidth, displayHeight, unit);
toalPrice = toalPrice+ parseFloat((rolls*area* wallRollPrice).toFixed(2));

html += `
<div class="rollPill">
  ${total} ${local_app_strings.roll} ${displayWidth}x${displayHeight}${displayUnit}
</div>
`
document.getElementById("summary").innerHTML = html
document.getElementById("rollCount").innerText = total
//let toalPrice = (parseFloat(total )* parseFloat(wallRollPrice).toFixed(2)).toFixed(2);
document.getElementById("ngs-final-price").innerHTML = rollPriceSymbol() + ' ' + toalPrice.toString()

  if(isFromCart==1)
  {
    let value = ` ${rolls} rolls of ${displayWidth}x${displayHeight} ${displayUnit}`
    propertiesHtml += `
    <input type="hidden" 
    name="properties[Rolls]" 
    value="${value}">`

     let wallCount = document.querySelectorAll(
        '#ngs-nv-roll-add-walls .ngs-nv-roll-wall'
    ).length;

    if (wallCount>3)
    {
       let isConnectChecked = document.getElementById('ngs-connect-wall-toggle-input').checked ? 'yes' : 'no';
       propertiesHtml += ` <input id="ngs_connectedRooms" type="hidden" name="properties[${local_app_strings.connectTheRooms}]" 
                        value="${isConnectChecked}">`
    }
    addPropertiesToOriginalForm(toalPrice,propertiesHtml);
  }
}

async function addPropertiesToOriginalForm(final_item_price,allWalllSizesHtml) {

            let tmp_custom_price = parseFloat(wallRollPrice);

            document.getElementById('ngs_custom_final_price').value = final_item_price.toFixed(2)
            document.getElementById('ngs_product_base_price').value = tmp_custom_price.toFixed(2)
            try {
                let finalCPrice = (final_item_price / Shopify.currency.rate).toFixed(2)
                 
                document.getElementById('ngs_custom_final_price').value = finalCPrice

                document.getElementById('ngs_product_base_price').value = (tmp_custom_price / Shopify.currency.rate).toFixed(2)
                document.getElementById('ngs_original_currency').value = Shopify.currency.active;


            }
            catch (ex) {

            }
              document.querySelector('.ngs-wall-property').innerHTML =allWalllSizesHtml
             
          
                document.getElementById('ngs_custom_spl_notes').value = document.getElementById('ngs-spl-instructions').value;
          
            
           
        }
        
function addCutomPropertiesToForm(apiMainSettingsData)
{
    const visibleForm = [...document.querySelectorAll(actualProductFormLocal)]
                        .find(el => el.offsetParent !== null);

    if (!visibleForm) return;

    // Prevent duplicate insertion
    if (visibleForm.querySelector('#ngs-nv-CustomProperties')) return;
     const oldGlobalProps = visibleForm.querySelector('#ngs_all_custom_properties_global');
    if (oldGlobalProps) {
        oldGlobalProps.remove();
    }

    let allPropsHtml = `<div id="ngs-nv-CustomProperties"> 
                <input id="ngs_custom_final_price" type="hidden" name="properties[__ngs_customPrice]" 
                value="0">
                <input id="ngs_custom_price_product_text" type="hidden" name="properties[__ngs_customPriceProductText]" 
                value="${apiMainSettingsData.customPriceProductText}">
                <input id="ngs_product_base_price" type="hidden" name="properties[__ngs_productBaseCurrencyPrice]" 
                value="0">
                <input id="ngs_original_currency" type="hidden" name="properties[__ngs_originalCurrency]" 
                value="0">
              
                <input id="ngs_all_properties_data" type="hidden" name="properties[__ngs_all_properties_data]" 
                        value="">
                  <div class="ngs-wall-property"></div>
                  
          </div>`
    visibleForm.insertAdjacentHTML("beforeend", allPropsHtml);
}




/*end NO visual roll calculatore*/